
import { Context } from '@nuxt/types'
import Vue from 'vue'
export default Vue.extend({

  data() {
    return {
      activeTab: 0
    }
  },

  watch: {
    '$route.params.slugCategory': function () {
      this.setupActiveIndex()
    }
  },

  methods: {

    tabChanged: function (index) {
      if(index !== 0) {
        const [key, value] = Object.entries(this.categories)[index - 1] // diff all index
        this.$store.commit('wp/updateBanner', {title: value.name, description: value.description})
      }
      else {
        this.$store.commit('wp/updateBanner', {title: this.$i18n.t('resourcesAllTitle'), description: this.$i18n.t('resourcesAllDescription')})
      }
    },
    setupActiveIndex: function () {
      if(this.$route.params.slugCategory){
        const categoryName = this.$route.params.slugCategory
        const categoryIndex = Object.entries(this.categories).findIndex(([key, value]) => {
          return value.slug === categoryName
        })
        this.activeTab = categoryIndex + 1 // diff all index
        const [key, value] = Object.entries(this.categories)[categoryIndex]
        this.$store.commit('wp/updateBanner', {title: value.name, description: value.description})
      }
      else {
        this.$store.commit('wp/updateBanner', {title: this.$i18n.t('resourcesAllTitle'), description: this.$i18n.t('resourcesAllDescription')})
        this.activeTab = 0
      }
    }
  },
  computed: {
    categories(): any[]{
      return this.$store.state.wp.categories
    }
  },

  mounted() {
    this.setupActiveIndex();
  },

})
